import module from 'guest/module.js'
import template from './template.html'

class GuestBancosComponent {
  constructor () {
    this.data = null
  }

  $onInit () {
    this.banco = Array.isArray(this.data) && this.data.length && this.data[0]
  }
}

module.component('guestBancos', {
  controller: GuestBancosComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/bancos/component.js